import React, { useEffect } from 'react'
import { useQuery } from 'react-query'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import SpinnerOverlay from '../components/SpinnerOverlay/SpinnerOverlay'
import { setTranslations } from '../store/slices/appSlice'

/* global window */
const TranslationsWrapper = ({ children }) => {
  const { translations } = useSelector((state) => state.app)
  const dispatch = useDispatch()

  const { data } = useQuery(
    'translations',
    () => axios.get('/api/translations').then((response) => response.data),
    {
      retry: true, // Will retry failed requests until success
    },
  )

  useEffect(() => {
    if (data) {
      dispatch(setTranslations(data))
      window.translations = data
    } else if (translations) {
      window.translations = translations
    }
  }, [data, translations])

  const hasTranslations = data && translations

  return (
    <SpinnerOverlay visible={!hasTranslations} allWhiteBackground>
      {hasTranslations ? children : null}
    </SpinnerOverlay>
  )
}

export default TranslationsWrapper
